import React from 'react';
import styles from './ActionButton.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const ActionButton = ({
  negative = false,
  text,
  onClick
}) => {
  return (
    <button className={cx('ActionButton', {'ActionButton--negative': negative})}
            onClick={onClick}>
      {text}
    </button>
  );
};

export default ActionButton;


// WEBPACK FOOTER //
// ./src/app/thermostats/components/ActionButton/ActionButton.js